const GTM_ID = 'GTM-5X4K8PGK';

export const GoogleTagManagerNoScript = () => (
  <noscript>
    <iframe
      src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
      title="Google Tag Manager"
    />
  </noscript>
);

const useGoogleTagManager = () => {
  // GTM is now initialized in public/index.html
  // This hook can be used for other GTM-related logic if needed in the future
};

export default useGoogleTagManager;
